import { Sparkle28Filled } from "@fluentui/react-icons";

export const AnswerIcon = () => {
    return (
        <div
            className="conversation-bot-avatar"
            style={{
                backgroundImage: "url('https://cdn-avatars.frase.io/7f40a34195d3469f923c416c97809532/4721.png')",
                width: "60px",
                height: "60px",
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "50%",
                flexShrink: "0",
                marginRight: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Adds a shadow effect
                border: "2px solid white" // Adds a white border around the logo
            }}
        ></div>
    );
};
